module.exports = __webpack_public_path__ + "img/money-check-pen.a5fd961f.svg";